import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  DateField,
  TextField,
  EditButton,
  TextInput,
  DateInput,
  FunctionField,
  SelectInput,
  useQuery,
  required,
  BulkDeleteButton,
  useDataProvider
} from 'react-admin'
import Box from '@mui/material/Box'
import BookIcon from '@mui/icons-material/Book'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'
import moment from 'moment'
import { Button } from '@mui/material'
import { useState } from 'react'
import SelectVideoman from '../Components/SelectVideoman'

export const VideoIcon = BookIcon

const MyBulkActionButtons = (props) => (
  <>
    <BulkDeleteButton
      undoable={false}
      confirmTitle='Suppression'
      confirmContent='Attention cette action est irréversible'
      {...props}
    />
  </>
)

let videomanChoice = window.variables.users.map((x) => ({
  id: x.userId.toString(),
  name: x.fullName || x.userName
}))
videomanChoice = [
  { id: 0, name: 'Selectionner un videoman' },
  ...videomanChoice
]

const videosFilters = [
  <TextInput
    variant='outlined'
    fullWidth
    source='search'
    label='Search'
    alwaysOn
  />,
  <SelectInput
    source='post_metas.link_video'
    label='Video'
    emptyText='Tous'
    choices={[
      { id: 'true', name: 'Renseigné' },
      { id: 'false', name: 'Vide' }
    ]}
  />,
  <SelectInput
    source='post_metas.video_vue_par'
    label='Video vue'
    emptyText='Tous'
    choices={[
      { id: 'true', name: 'Vue' },
      { id: 'false', name: 'Non visionnée' }
    ]}
  />,
  <SelectInput
    source='post_metas.videoman'
    label='Videoman'
    choices={videomanChoice}
  />
]

const ButtonEnvoieMail = ({ reccord }) => {
  const handleSendMail = (info) => {
    const data = new FormData()

    data.append('action', 'send_ready_mail')
    data.append('nonce', window.variables.nonce)
    data.append('id', info.id)

    console.log({ reccord,info });
    
    fetch(`${window.variables.ajaxUrl}`, {
      method: 'POST',
      credentials: 'same-origin',
      body: data
    })
      .then((res) => res.json())
      .then((r) => {
        console.log({ r,data:r.data });

        if (r?.data?.send) {
          window.alert('Le mail a bien été envoyé')
        } else {
          window.alert('Erreur')
        }
      })
  }

  if (reccord?.post_metas?.link_video) {
    return (
      <div>
        <Button onClick={() => handleSendMail(reccord)}> mail</Button>
        {reccord?.post_metas?.mail_send && (
          <>
            <br />
            Mail envoyé le
            {moment(reccord?.post_metas?.mail_send * 1000).format(
              'DD/MM/YYYY à HH:mm'
            )}
          </>
        )}
      </div>
    )
  }

  return 'Pas de vidéo'
}

export const VideoList = (props) => {
  const dataProvider = useDataProvider()
  const [loading, setLoading] = useState(false)
  const handleVideoman = async (row, videoman) => {
    setLoading(row.id)
    await dataProvider.update('video-tandem', {
      data: { ...row, post_metas: { ...row.post_metas, videoman } }
    })
    setLoading(false)
  }

  return (
    <div>
      <List
        {...props}
        perPage={25}
        filters={videosFilters}
        sort={{ field: 'id', order: 'DESC' }}
        bulkActionButtons={<MyBulkActionButtons />}>
        <Datagrid>
          <TextField source='id' />
          <TextField
            source='post_metas.nom'
            label='Nom'
            textAlign='center'
            sortable={false}
          />
          <TextField
            source='post_metas.prenom'
            label='prenom'
            textAlign='center'
            sortable={false}
          />
          <TextField
            source='post_metas.email'
            label='email'
            textAlign='center'
            sortable={false}
          />
          <DateField
            label='Date'
            source='date'
            locales='fr-Fr'
            textAlign='center'
            sortable={false}
          />

          <FunctionField
            label='Videoman'
            textAlign='center'
            sortable
            render={(reccord) => (
              <SelectVideoman
                loading={loading === reccord.id}
                handleVideoman={handleVideoman}
                data={reccord}
              />
            )}
          />
          <FunctionField
            label='Video'
            textAlign='center'
            sortable={false}
            render={(reccord) =>
              reccord?.post_metas.link_video ? (
                <ThumbUpIcon style={{ color: 'green' }} />
              ) : (
                <SentimentDissatisfiedIcon style={{ color: 'red' }} />
              )
            }
          />

          <FunctionField
            label='Video vue'
            textAlign='center'
            sortable={false}
            render={(reccord) =>
              reccord?.post_metas?.date_vue ? (
                moment(reccord.post_metas.date_vue).format('DD/MM/YYYY')
              ) : (
                <SentimentDissatisfiedIcon style={{ color: 'red' }} />
              )
            }
          />
          <FunctionField
            label='CGU acceptées'
            textAlign='center'
            sortable={false}
            render={(reccord) =>
              reccord?.post_metas.cgu_video ? (
                <ThumbUpIcon style={{ color: 'green' }} />
              ) : (
                <SentimentDissatisfiedIcon style={{ color: 'red' }} />
              )
            }
          />

          <FunctionField
            label='Envoi mail'
            textAlign='center'
            sortable={false}
            render={(reccord) => <ButtonEnvoieMail reccord={reccord} />}
          />
          <FunctionField
            label='Lien'
            textAlign='center'
            sortable={false}
            render={(reccord) =>
              reccord?.post_metas?.link_video ? (
                <Button
                  href={reccord?.link}
                  target='_blank'
                  variant='contained'>
                  Voir
                </Button>
              ) : (
                <></>
              )
            }
          />

          <EditButton />
        </Datagrid>
      </List>
    </div>
  )
}

const VideoTitle = ({ reccord }) => (
  <span>Vidéo {reccord ? `"${reccord.title}"` : ''}</span>
)

const LinkVideo = ({ data }) =>
  data?.link ? null : (
    <Button
      sx={{ marginBottom: '10px' }}
      href={data?.link}
      target='_blank'
      variant='contained'>
      Voir la page
    </Button>
  )

export const VideoEdit = (props) => {
  const { data, loading, error } = useQuery({
    type: 'getOne',
    resource: 'video-tandem',
    payload: { id: props.id }
  })

  // const [wait, setWait] = useState(true)
  // const [vdoActive, setVdoActive] = useState(false)
  // const [photosActive, setPhotosActive] = useState(false)

  // useEffect(() => {
  //   setVdoActive(data?.post_metas?.vdo_active)
  //   setPhotosActive(data?.post_metas?.photos_active)
  //   setWait(false)
  // }, [data])

  // const validateUserCreation = (values) => {
  //   const errors = {}
  //   setVdoActive(values?.post_metas?.vdo_active)
  //   setPhotosActive(values?.post_metas?.photos_active)
  //   return errors
  // }

  return (
    <Edit title={<VideoTitle />} {...props} mutationMode='pessimistic'>
      <SimpleForm>
        <LinkVideo data={data} />
        <SelectInput
          source='post_metas.videoman'
          label='Videoman'
          choices={videomanChoice}
        />
        <Box sx={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
          <Box sx={{ width: '50%', padding: '5px' }}>
            <TextInput
              validate={required()}
              variant='outlined'
              fullWidth
              source='post_metas.nom'
              label='Nom'
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            <TextInput
              validate={required()}
              variant='outlined'
              fullWidth
              source='post_metas.prenom'
              label='prenom'
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            <TextInput
              validate={required()}
              variant='outlined'
              fullWidth
              source='post_metas.email'
              label='email'
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            <DateInput
              fullWidth
              validate={required()}
              label='Publication date'
              source='date'
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            <TextInput
              variant='outlined'
              fullWidth
              source='post_metas.link_video'
              label='Lien du dossier vidéo'
              helperText={
                data?.post_metas?.video_ajouter_par
                  ? `video ajouté par ${data?.post_metas?.video_ajouter_par}`
                  : false
              }
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            CGU acceptées :
            <FunctionField
              render={(reccord) =>
                reccord?.post_metas.cgu_video ? (
                  <ThumbUpIcon style={{ color: 'green' }} />
                ) : (
                  <SentimentDissatisfiedIcon style={{ color: 'red' }} />
                )
              }
            />
          </Box>
          <Box sx={{ width: '50%', padding: '5px' }}>
            Vidéo vue le :{' '}
            <FunctionField
              render={(reccord) =>
                reccord.post_metas.date_vue
                  ? moment(reccord.post_metas.date_vue).format('DD/MM/YYYY')
                  : '-'
              }
            />
            <br />
            Mailling :{' '}
            <FunctionField
              render={(reccord) => <ButtonEnvoieMail reccord={reccord} />}
            />
          </Box>
        </Box>
      </SimpleForm>
    </Edit>
  )
}
